// @ts-nocheck
import { useEffect, useState } from "react"
import { supabaseClient } from "@/lib/supabase/client"
import { PostCard } from "@/components/post/PostCard"
import { useAuth } from "@/components/layout/AuthProvider"

export default function TrendingPage() {
  const { supabaseUser } = useAuth()
  const [posts, setPosts] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabaseClient.from("posts")
      .select("*, users!posts_author_id_fkey(id,username,display_name,avatar_url,is_verified), post_topics(topics(id,name,slug))")
      .eq("status", "published")
      .order("vote_score", { ascending: false })
      .limit(30)
      .then(({ data }) => {
        setPosts((data || []).map((p: any) => ({ ...p, author: p.users, topic: p.post_topics?.[0]?.topics })))
        setLoading(false)
      })
  }, [])

  return (
    <div className="container-narrow py-4 pb-20 lg:pb-4">
      <div className="flex items-center gap-2 mb-4">
        <svg className="w-5 h-5 text-brand" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
        </svg>
        <h1 className="font-syne font-bold text-xl">Popular</h1>
      </div>
      {loading ? (
        <div className="space-y-2">{[1,2,3,4,5].map(i => <div key={i} className="skeleton h-24 rounded" />)}</div>
      ) : posts.length === 0 ? (
        <div className="panel p-12 text-center"><p className="font-syne font-bold text-lg">Nothing trending yet</p></div>
      ) : (
        <div className="space-y-2">
          {posts.map(p => <PostCard key={p.id} post={p} userId={supabaseUser?.id || null} />)}
        </div>
      )}
    </div>
  )
}
